export default __webpack_public_path__ + "static/media/trash-icon.795a0705.svg";